import upgrade from "./upgrade.jpeg";

export {
    upgrade
}